
export const HospitalData = [
    {
        img: "./hospiImg/AIIMS, Rishikesh Trauma Center.jpeg",
        name: 'AIIMS, Rishikesh Trauma Center',
        location: 'https://www.google.com/maps/dir/22.8196352,75.9431168/AIIMS+Rishikesh+Trauma,+249,+Virbhadra+Rd,+Sturida+Colony,+Rishikesh,+Uttarakhand+249201/@26.3422321,72.3534678,6z/data=!3m1!4b1!4m9!4m8!1m1!4e1!1m5!1m1!1s0x39093e00d9671fa1:0x80854d06f5dfa9bb!2m2!1d78.2884453!2d30.0918208'
    },
    {
        img: "./hospiImg/B.D. Pandey Hospital, Nainital.jpg",
        name: 'B.D. Pandey Hospital, Nainital',
        location: 'https://www.google.com/maps/dir//b+d+pandey+hospital+nainital/data=!4m6!4m5!1m1!4e2!1m2!1m1!1s0x39a0a1ecaa23e501:0xebd2242bb52581a1?sa=X&ved=2ahUKEwjl5taWtbr-AhVBzjgGHVskAUgQ9Rd6BAhbEAM'
    },
    {
        img: "./hospiImg/Base Hospital, Haldwani.jpeg",
        name: 'Base Hospital, Haldwani',
        location: 'https://www.google.com/maps?q=Base+Hospital,+Haldwani&um=1&ie=UTF-8&sa=X&ved=2ahUKEwikzKjetbr-AhWBXGwGHX9qAa4Q_AUoAXoECAEQAw'
    },
    {
        img: "./hospiImg/Base Hospital, Ranikhet.jpg",
        name: 'Base Hospital, Ranikhet',
        location: 'https://www.google.com/maps?q=Base+Hospital,+Ranikhet&um=1&ie=UTF-8&sa=X&ved=2ahUKEwji54H-tbr-AhUoSGwGHWMLCIAQ_AUoAXoECAIQAw'
    },
    {
        img: "./hospiImg/City Hospital, Dehradun.jpeg",
        name: 'City Hospital, Dehradun',
        location: 'https://www.google.com/maps/place/Dr.Amit+Kansal+(City+Hospital)+-+orthopedic+doctor+in+dehradun+%7C+orthopedic+surgeon+in+dehradun+%7C+knee+replacement+doctor/@30.3274266,78.0300857,17z/data=!3m1!4b1!4m6!3m5!1s0x3909291668dd1af9:0x56ec4e650e771816!8m2!3d30.3274266!4d78.0322744!16s%2Fg%2F11jx6nhy3x'
    },
    
]